import { Box, type TextFieldProps } from "@mui/material";
import { DragNDrop } from "Components/Shared/DragNDrop";
import { StyledInputLabel } from "Components/Shared/StyledComponents";
import { useId } from "react";
import {
  type Control,
  Controller,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";

type Props<
  FormType extends FieldValues,
  TransformedFieldValues = FormType,
> = TextFieldProps & {
  name: FieldPath<FormType>;
  label?: string;
  control: Control<FormType, unknown, TransformedFieldValues>;
  disabled?: boolean;
  type?: string;
  title: string;
  description?: string;
};

export const BlFileInputForm = <T extends object, V extends object>(
  props: Props<T, V>,
) => {
  const { name, control, label, title, description } = props;
  const inputId = useId();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <Box overflow="hidden">
            {!!label && (
              <StyledInputLabel htmlFor={inputId}>{label}</StyledInputLabel>
            )}
            <DragNDrop
              file={value}
              onChange={onChange}
              title={title}
              description={description}
              id={inputId}
              isError={!!error}
            />
            {!!error && (
              <div style={{ color: "red" }}>
                {error.message || "This field is required"}
              </div>
            )}
          </Box>
        );
      }}
    />
  );
};
